import { render, staticRenderFns } from "./BnVaros.vue?vue&type=template&id=a851a334&scoped=true&"
import script from "./BnVaros.vue?vue&type=script&lang=js&"
export * from "./BnVaros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a851a334",
  null
  
)

export default component.exports